import React from "react";
import { useState, useEffect } from "react";
import Select from "../Select";
import Page from "./Page.jsx";
import styles from "./pagination.module.css";

interface Props_t {
  pages: number,
  onCurrentPageSet: (arg0: number) => void,
  perPageOptions: number[],
  onPerPageChanged: (arg0: number) => void,
  // fixme: set right type 
  toggleResetCurrPage: any,
  currentPageInit: number,
  perPage: number,
  setPerPage: (arg0: number) => void
}
export default function Pagination({ pages = 1, onCurrentPageSet, perPageOptions = [10], onPerPageChanged, toggleResetCurrPage, currentPageInit = 1, perPage, setPerPage }: Props_t) {
  let [pagesArr, setPagesArr] = useState<number[]>([]);
  let [currentPage, setCurrentPage] = useState<number>(currentPageInit);
  const [goToVal, setGoToVal] = useState<'' | number>('');

  useEffect(() => {
    let arr: [] | number[] = [];
    pages = pages === 0 ? 1 : pages;
    for (let i = 1; i <= pages; i++) {
      arr[i - 1] = i;
    }
    setPagesArr(arr);
  }, [pages]);

  useEffect(() => {
    onCurrentPageSet(currentPage);
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [toggleResetCurrPage]);

  useEffect(() => {
    setCurrentPage(currentPageInit)
  }, [currentPageInit]);

  useEffect(() => {
    if (!goToVal) return;
    setCurrentPage(goToVal)
    console.log(currentPage, 'current page')
  }, [goToVal])

  let goToPage = (page: number) => {
    setCurrentPage(page);
    setGoToVal(page);
  }

  let goToLastPage = () => {
    setCurrentPage(pages);
    setGoToVal(pages)
  }

  let goToPrevPage = () => {
    if (currentPage === 1) return;
    setCurrentPage(currentPage - 1);
    setGoToVal(currentPage - 1);
  }

  let goToNextPage = () => {
    if (currentPage === pages) return;
    setCurrentPage(currentPage + 1);
    setGoToVal(currentPage + 1)
  }

  let onSetPerPage = (e: { target: { value: string }; }) => {
    let perPage = Number(e.target.value);
    setPerPage(perPage);
    onPerPageChanged(perPage);
    setCurrentPage(1);
  }
  const showPageNum = (page: number): Boolean => currentPage - 1 === page || currentPage + 1 === page || currentPage === page;

  const renderPages = () => {
    return (pagesArr.map((page, i) => {
      if (showPageNum(page)) {
        return (
          <Page
            key={i}
            page={page}
            isCurrent={page === currentPage}
            goToPage={goToPage} />)
      }
    }))
  }

  const handleGoTo = (e: React.ChangeEvent<HTMLInputElement>): void => {
    let value = Number(e.target.value);
    if (value <= 0) return;
    if (value <= pages) {
      setGoToVal(value);
    }
    if (value > pages) {
      // take last digit and go to that page
      let newVal = Number(e.target.value[e.target.value.length - 1]);
      if (newVal !== 0 && newVal <= pages) {
        setGoToVal(newVal);
      }
    }
  };
  return (
    <div className={styles["pagination-wrapper"]}>
      <div className={styles['pagination-left']}>
        <div className={styles["per-page"]}>
          <Select options={perPageOptions} value={perPage as any} onChange={onSetPerPage} name="perPage" />
          <span className="active">items per page</span>
        </div>
        <div style={{ width: '100px' }} className={styles["per-page"]}>
          <span>Go to</span>
          <input min="1" type='number' value={goToVal} onChange={handleGoTo} />
        </div>
      </div>

      <div className={styles['pagination']}>
        <div className={styles['page']} onClick={() => goToPage(1)}>
          <i className="material-icons">first_page</i>
        </div>
        <div className={styles['page']} onClick={goToPrevPage}>
          <i className="material-icons">keyboard_arrow_left</i>
        </div>
        {renderPages()}
        <div className={styles['page']} onClick={goToNextPage}>
          <i className="material-icons">keyboard_arrow_right</i>
        </div>
        <div className={styles['page']}>
          <i className="material-icons" onClick={goToLastPage}>last_page</i>
        </div>
      </div>
    </div>
  )
}
